import userInfo from '@/views/setting/views/userInfo/userInfo';
export default userInfo;